import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../../models/api.model';
import { Discount } from '../models/discount.model';

@Injectable({
  providedIn: 'root',
})
export class DiscountsService {
  private http = inject(HttpClient);

  private apiRoot = '/bo/discount-codes';

  public getAll$(page?: number): Observable<ApiResponse<Discount[]>> {
    let query = '';
    if (page) {
      query = '?page=' + page;
    }
    return this.http.get<ApiResponse<Discount[]>>(
      environment.apiURl + `${this.apiRoot}${query}`
    );
  }

  public get$(id: number): Observable<ApiResponse<Discount>> {
    return this.http.get<ApiResponse<Discount>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public create$(
    body: Discount,
    nm?: Array<string | number>
  ): Observable<ApiResponse<Discount>> {
    const payload = {
      code: body.code,
      description: body.description,
      discountPercentage: body.discountPercentage,
      enabled: body.enabled,
      maxUses: body.maxUses,
      minBalance: body.minBalance,
      maxBalance: body.maxBalance,
      validFrom: this.formatDatetime(body.validFrom),
      validUntil: this.formatDatetime(body.validUntil),
      events: nm ?? [],
    };
    return this.http.post<ApiResponse<Discount>>(
      environment.apiURl + `${this.apiRoot}`,
      payload
    );
  }

  public delete$(id: number): Observable<ApiResponse<Pick<Discount, 'id'>>> {
    return this.http.delete<ApiResponse<Pick<Discount, 'id'>>>(
      environment.apiURl + `${this.apiRoot}/${id}`
    );
  }

  public update$(
    body: Discount,
    nm?: Array<string | number>
  ): Observable<ApiResponse<Discount>> {
    const payload = {
      code: body.code,
      description: body.description,
      discountPercentage: body.discountPercentage,
      enabled: body.enabled,
      maxUses: body.maxUses,
      minBalance: body.minBalance,
      maxBalance: body.maxBalance,
      validFrom: this.formatDatetime(body.validFrom),
      validUntil: this.formatDatetime(body.validUntil),
      events: nm ?? [],
    };
    return this.http.patch<ApiResponse<Discount>>(
      environment.apiURl + `${this.apiRoot}/${body.id}`,
      payload
    );
  }

  private formatDatetime(value: string | null): string | null {
    if (!value) return null;
    let formatted = value;
    if (formatted.length === 16) {
      formatted += ':00';
    }
    if (!formatted.endsWith('Z')) {
      formatted += 'Z';
    }
    return formatted;
  }
}
